import { useEffect } from 'react';
import triggerAnalyticsEvent from 'syf-js-utilities/helpers/triggerAnalyticsEvent';
import { getPromoCenterDetailsAnalyticsEvent, getPromoCenterTabAnalyticsEvent, getPromoCenterTabEventName } from '../const/analytics/promo-center';
const analyticsFnMap = {
    promoCenterDetails: getPromoCenterDetailsAnalyticsEvent,
    promoCenterTab: getPromoCenterTabAnalyticsEvent
};
const useTriggerAnalyticsEvent = (featureEvent, promotions, shouldTrigger = true) => {
    useEffect(() => {
        const [feature, eventName] = featureEvent.split('.');
        if (!shouldTrigger)
            return;
        if (feature === 'promoCenterDetails') {
            triggerAnalyticsEvent(analyticsFnMap[feature](eventName));
        }
        else if (feature === 'promoCenterTab') {
            let tabEventName = eventName;
            if (promotions === null || promotions === void 0 ? void 0 : promotions.active) {
                tabEventName = getPromoCenterTabEventName(promotions === null || promotions === void 0 ? void 0 : promotions.active, promotions === null || promotions === void 0 ? void 0 : promotions.expired);
            }
            triggerAnalyticsEvent(analyticsFnMap[feature](tabEventName));
        }
    }, [featureEvent, promotions, shouldTrigger]);
};
export default useTriggerAnalyticsEvent;
//# sourceMappingURL=use-trigger-analytics-event.js.map